import { commonTexts } from './common'
import type { BookPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  quoteColor: 'rgba(166, 107, 255, 0.28)',
  tocLockColor: brandTheme.primaryColor,
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
